<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div class="trezo-card-content">
      <SettingsNav />

      <form>
        <h5 class="text-lg mb-[6px]">{{ directT('settings.accountSettings.profile') }}</h5>
        <p class="mb-[20px] md:mb-[25px]">
          {{ directT('settings.accountSettings.updatePhotoAndDetails') }}
        </p>
        <div class="sm:grid sm:grid-cols-2 sm:gap-[25px]">
          <div class="mb-[20px] sm:mb-0">
            <label
              class="mb-[10px] text-black dark:text-white font-medium block"
            >
              {{ directT('settings.accountSettings.firstName') }}
            </label>
            <input
              type="text"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              value="Olivia"
              v-model="profileData.first_name"
            />
          </div>
          <div class="mb-[20px] sm:mb-0">
            <label
              class="mb-[10px] text-black dark:text-white font-medium block"
            >
              {{ directT('settings.accountSettings.lastName') }}
            </label>
            <input
              type="text"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              value="John"
              v-model="profileData.last_name"
            />
          </div>
          <div class="mb-[20px] sm:mb-0">
            <label
              class="mb-[10px] text-black dark:text-white font-medium block"
            >
              {{ directT('settings.accountSettings.emailAddress') }}
            </label>
            <input
              type="text"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              value="olivia@clickai.live"
              v-model="profileData.email"
              disabled
            />
          </div>
          <div class="mb-[20px] sm:mb-0">
            <label
              class="mb-[10px] text-black dark:text-white font-medium block"
            >
              {{ directT('settings.accountSettings.phoneNumber') }}
            </label>
            <input
              type="text"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              value="+1 444 555 6699"
              v-model="profileData.phone"
            />
          </div>
          <div class="mb-[20px] sm:mb-0">
            <label
              class="mb-[10px] text-black dark:text-white font-medium block"
            >
              {{ directT('settings.accountSettings.location') }}
            </label>
            <input
              type="text"
              class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
              :placeholder="directT('settings.accountSettings.enterYourLocation')"
              v-model="profileData.location"
            />
          </div>
        </div>
        <h5 class="text-lg mb-[6px] mt-[20px] md:mt-[25px]">{{ directT('settings.accountSettings.profileInfo') }}</h5>
        <p class="mb-[20px] md:mb-[25px]">
          {{ directT('settings.accountSettings.displayedProfile') }}
        </p>
        <div id="fileUploader">
          <div
            class="relative flex items-center justify-center overflow-hidden rounded-md py-[88px] px-[20px] border border-gray-200 dark:border-[#172036]"
          >
            <div v-if="profileData.profile_picture_link" class="mb-4 text-center">
              <img 
                :src="profileData.profile_picture_link" 
                alt="Profile Picture" 
                class="mx-auto w-[150px] h-[150px] object-cover rounded-full mb-2"
              />
              <p class="text-primary-500">{{ directT('settings.accountSettings.currentImage') }}</p>
            </div>
            <div class="flex items-center justify-center">
              <div
                class="w-[35px] h-[35px] border border-gray-100 dark:border-[#15203c] flex items-center justify-center rounded-md text-primary-500 text-lg ltr:mr-[12px] rtl:ml-[12px]"
              >
                <i class="ri-upload-2-line"></i>
              </div>
              <p class="leading-[1.5]">
                <strong class="text-black dark:text-white"
                  >{{ directT('settings.accountSettings.clickToUpload') }}</strong
                ><br />
                {{ directT('settings.accountSettings.yourFileHere') }}
              </p>
            </div>
            <input
              type="file"
              id="fileInput"
              class="absolute top-0 left-0 right-0 bottom-0 rounded-md z-[1] opacity-0 cursor-pointer"
              @change="handleProfilePictureUpload"
              accept="image/*"
            />
          </div>
          <div v-if="uploadStatus" class="mt-2 text-center" :class="{'text-green-500': uploadStatus === 'success', 'text-red-500': uploadStatus === 'error'}">
            {{ uploadStatusMessage }}
          </div>
        </div>
        <div class="mt-[20px] md:mt-[25px]">
          <button
            type="button"
            class="font-medium inline-block transition-all rounded-md md:text-md ltr:mr-[15px] rtl:ml-[15px] py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-danger-500 text-white hover:bg-danger-400"
            @click="resetForm"
          >
            {{ directT('settings.accountSettings.cancel') }}
          </button>
          <button
            type="button"
            class="font-medium inline-block transition-all rounded-md md:text-md py-[10px] md:py-[12px] px-[20px] md:px-[22px] bg-primary-500 text-white hover:bg-primary-400"
            @click="updateProfile"
            :disabled="isLoading"
          >
            <span class="inline-block relative ltr:pl-[29px] rtl:pr-[29px]">
              <i
                class="material-symbols-outlined ltr:left-0 rtl:right-0 absolute top-1/2 -translate-y-1/2"
              >
                check
              </i>
              {{ isLoading ? directT('settings.accountSettings.updating') : directT('settings.accountSettings.updateProfile') }}
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import SettingsNav from "../SettingsNav.vue";
import { supabase } from '@/utils/supabase';
import { useI18n } from "vue-i18n";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

type TranslationRecord = Record<string, any>;
type TranslationsType = Record<string, TranslationRecord>;

const allTranslations: TranslationsType = {
  en: enTranslations,
  he: heTranslations,
  ar: arTranslations,
};

export default defineComponent({
  name: "AccountSettings",
  components: {
    SettingsNav,
  },
  setup() {
    const { t, locale } = useI18n();

    // Profile data
    const profileData = ref({
      id: '',
      user_id: '',
      display_name: '',
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      location: '',
      role: '',
      profile_picture_link: '',
      country: '',
      birth_date: '',
      gender: '',
      skills: '',
      profession: '',
      company_name: '',
      company_website: '',
      bio: '',
      facebook: '',
      twitter: '',
      linkedin: '',
      youtube: ''
    });
    
    const isLoading = ref(false);
    const uploadStatus = ref('');
    const uploadStatusMessage = ref('');

    // Direct translation function with fallback
    function directT(key: string): string {
      const parts = key.split('.');
      let result: any = allTranslations[locale.value] || allTranslations.en;
      
      for (const part of parts) {
        if (result && typeof result === 'object' && part in result) {
          result = result[part];
        } else {
          // Fallback to English if key doesn't exist
          let englishResult = allTranslations.en;
          for (const engPart of parts) {
            if (englishResult && typeof englishResult === 'object' && engPart in englishResult) {
              englishResult = englishResult[engPart];
            } else {
              return key; // Return the key itself if not found in English either
            }
          }
          return typeof englishResult === 'string' ? englishResult : key;
        }
      }
      
      return typeof result === 'string' ? result : key;
    }

    // פונקציה לטעינת נתוני המשתמש
    const loadUserProfile = async () => {
      try {
        // קבלת המשתמש הנוכחי
        const { data: { session } } = await supabase.auth.getSession();
        
        if (session && session.user) {
          // קבלת פרטי הפרופיל מהמסד נתונים
          const { data, error } = await supabase
            .from('user_profiles')
            .select('*')
            .eq('user_id', session.user.id)
            .single();
          
          if (error) {
            console.error('שגיאה בטעינת פרופיל המשתמש:', error);
            return;
          }
          
          // אתחול הנתונים מהמסד נתונים
          if (data) {
            // פיצול display_name לשם פרטי ושם משפחה אם קיים
            const nameParts = data.display_name ? data.display_name.split(' ') : ['', ''];
            
            profileData.value = {
              ...profileData.value,
              ...data,
              first_name: nameParts[0] || '',
              last_name: nameParts.slice(1).join(' ') || '',
              email: session.user.email || '',
              // location שמתאים במקום address
              location: data.location || ''
            };
          }
        }
      } catch (error) {
        console.error('שגיאה בטעינת נתוני המשתמש:', error);
      }
    };

    // פונקציה לטיפול בהעלאת תמונת פרופיל
    const handleProfilePictureUpload = async (event: Event) => {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      
      if (!file) return;
      
      try {
        isLoading.value = true;
        uploadStatus.value = '';
        uploadStatusMessage.value = '';
        
        // בדיקה שהקובץ הוא תמונה
        if (!file.type.startsWith('image/')) {
          uploadStatus.value = 'error';
          uploadStatusMessage.value = 'יש להעלות קובץ תמונה בלבד';
          return;
        }
        
        // הגבלת גודל הקובץ (5MB)
        if (file.size > 5 * 1024 * 1024) {
          uploadStatus.value = 'error';
          uploadStatusMessage.value = 'גודל הקובץ לא יכול לעלות על 5MB';
          return;
        }
        
        // יצירת שם קובץ ייחודי באמצעות תאריך ושם המקורי
        const { data: { session } } = await supabase.auth.getSession();
        if (!session || !session.user) {
          uploadStatus.value = 'error';
          uploadStatusMessage.value = 'אתה לא מחובר למערכת';
          return;
        }
        
        const fileExt = file.name.split('.').pop();
        const fileName = `${session.user.id}_${Date.now()}.${fileExt}`;
        
        // העלאת הקובץ ל- Storage של Supabase
        const { data, error } = await supabase.storage
          .from('profilepictures')
          .upload(fileName, file, {
            cacheControl: '3600',
            upsert: true
          });
        
        if (error) {
          console.error('שגיאה בהעלאת התמונה:', error);
          uploadStatus.value = 'error';
          uploadStatusMessage.value = 'שגיאה בהעלאת התמונה: ' + error.message;
          return;
        }
        
        // יצירת ה-URL הציבורי לתמונה
        const { data: { publicUrl } } = supabase.storage
          .from('profilepictures')
          .getPublicUrl(fileName);
        
        // עדכון הפרופיל עם הקישור החדש
        profileData.value.profile_picture_link = publicUrl;
        
        // עדכון בטבלת user_profiles - רק את העמודה profile_picture_link
        const { error: updateError } = await supabase
          .from('user_profiles')
          .update({ 
            profile_picture_link: publicUrl
            // כל שדה אחר לא יעודכן כאן
          })
          .eq('user_id', session.user.id);
        
        if (updateError) {
          console.error('שגיאה בעדכון פרטי המשתמש:', updateError);
          uploadStatus.value = 'error';
          uploadStatusMessage.value = 'שגיאה בעדכון פרטי המשתמש: ' + updateError.message;
          return;
        }
        
        uploadStatus.value = 'success';
        uploadStatusMessage.value = 'התמונה הועלתה בהצלחה!';
      } catch (error) {
        console.error('שגיאה לא צפויה:', error);
        uploadStatus.value = 'error';
        uploadStatusMessage.value = 'שגיאה לא צפויה בהעלאת התמונה';
      } finally {
        isLoading.value = false;
      }
    };

    // פונקציה לעדכון פרופיל המשתמש
    const updateProfile = async () => {
      try {
        isLoading.value = true;
        
        const { data: { session } } = await supabase.auth.getSession();
        if (!session || !session.user) {
          console.error('המשתמש לא מחובר');
          return;
        }
        
        // יצירת display_name משם פרטי ומשפחה
        const displayName = `${profileData.value.first_name} ${profileData.value.last_name}`.trim();
        
        // עדכון הפרופיל במסד הנתונים - רק עמודות שקיימות בטבלה
        const { error } = await supabase
          .from('user_profiles')
          .update({
            display_name: displayName,
            phone: profileData.value.phone,
            location: profileData.value.location, // במקום address
            // לא כולל שדות שאינם קיימים בטבלה
          })
          .eq('user_id', session.user.id);
        
        if (error) {
          console.error('שגיאה בעדכון הפרופיל:', error);
          uploadStatus.value = 'error';
          uploadStatusMessage.value = 'שגיאה בעדכון הפרופיל: ' + error.message;
          return;
        }
        
        uploadStatus.value = 'success';
        uploadStatusMessage.value = 'הפרופיל עודכן בהצלחה!';
      } catch (error) {
        console.error('שגיאה לא צפויה:', error);
        uploadStatus.value = 'error';
        uploadStatusMessage.value = 'שגיאה לא צפויה בעדכון הפרופיל';
      } finally {
        isLoading.value = false;
      }
    };

    // איפוס הטופס
    const resetForm = () => {
      loadUserProfile();
      uploadStatus.value = '';
      uploadStatusMessage.value = '';
    };
    
    // טעינת נתוני המשתמש בעת טעינת הקומפוננט
    onMounted(() => {
      loadUserProfile();
    });
    
    return {
      profileData,
      isLoading,
      uploadStatus,
      uploadStatusMessage,
      directT,
      handleProfilePictureUpload,
      updateProfile,
      resetForm
    };
  }
});
</script>
